import config from "@/config";
import http from "@/utils/request";

export default {
	message: {
		url: `${config.API_URL}/api/ly/workbench/data`,
		name: "工作台数据展示",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	list: {
		url: `${config.API_URL}/api/ly/workbench/todo`,
		name: "待办事项",
		get: async function (data = {}, config = {}) {
			return await http.get(this.url, data, config);
		},
	},
	phoneCount: {
		url: `${config.API_URL}/api/ly/workbench/phoneCount`,
		name: "获取用户手机号码归属地统计",
		get: async function (data = {}) {
			return await http.get(this.url, data);
		},
	},
	// status: {
	//   url: `${config.API_URL}/api/ly/distributor/updateStatus`,
	//   name: "权限设置",
	//   post: async function (data = {}, config = {}) {
	//     return await http.post(this.url, data, config);
	//   },
	// },
	// remark: {
	//   url: `${config.API_URL}/api/ly/distributor/updateRemark`,
	//   name: "设置备注",
	//   post: async function (data = {}, config = {}) {
	//     return await http.post(this.url, data, config);
	//   },
	// },
	// log: {
	//   url: `${config.API_URL}/api/ly/distributor/log`,
	//   name: "日志",
	//   get: async function (data = {}) {
	//     return await http.get(`${this.url}/${data}`);
	//   },
	// },
	// treeList: {
	//   url: `${config.API_URL}/api/ly/distributor/tree`,
	//   name: "分销商关系树形图",
	//   get: async function (data = {}, config = {}) {
	//     return await http.get(this.url, data, config);
	//   },
	// },
};
